var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { htmlToSource } from "./VTRichTextEditor";
import $ from "jquery";
export function VTRichTextEditorContentPreview(_a) {
    var sx = _a.sx, htmlContent = _a.htmlContent, onClick = _a.onClick, onHover = _a.onHover;
    var _b = __read(useState(""), 2), marshalledHtmlContent = _b[0], setMarshalledHtmlContent = _b[1];
    useEffect(function () {
        var domTreeAsArray = $.parseHTML(htmlContent);
        var $rootSelector = $(domTreeAsArray[0]);
        var $imgsSelector = $rootSelector.find("img");
        $imgsSelector.attr({ id: "" });
        $imgsSelector.attr({ class: "" });
        var marshalledHtmlString = htmlToSource($rootSelector);
        setMarshalledHtmlContent(marshalledHtmlString);
    }, [htmlContent]);
    return (_jsx(Box, __assign({ onClick: onClick, onMouseOver: function () { return onHover && onHover(true); }, onMouseLeave: function () { return onHover && onHover(false); }, component: "div", sx: __assign({}, sx) }, { children: _jsx("div", { id: "rich-text-preview", onBeforeInput: function () { }, onClick: function (e) {
                e.preventDefault();
            }, onSelect: function (e) { }, dangerouslySetInnerHTML: { __html: marshalledHtmlContent }, style: {
                // opacity: 1,
                // zIndex: 100000,
                // overflow: "scroll",
                width: "100%",
                height: "100%",
                //   padding: "10px",
                // outline: "none",
            } }) })));
}
